import React, { useContext } from "react";
import InputCheckList from "core/inputs/input-check-list/InputCheckList";
import { MISSION_TYPE } from "constants/constants";
import { FormattedMessage } from "react-intl";
import InfoContext from "pages/InfoContext";

const MissionTypeField = () => {
  const { storedMissionType, setStoredMissionType, setValue } =
    useContext(InfoContext);

  return (
    <>
      <div className="label sourcesanspro-normal-shadow-blue-14px label-standard">
        <FormattedMessage id="mission_type" defaultMessage="Type de mission" />
      </div>
      <div className="input-select-inputs">
        <InputCheckList
          onChange={(value) => {
            setStoredMissionType(value);
            return setValue("mission_type_filter", value);
          }}
          value={storedMissionType.length > 0 ? storedMissionType : []}
          infoList={MISSION_TYPE}
          required={false}
          readOnly={false}
          id="mission-type-filter"
        />
      </div>
    </>
  );
};

export default MissionTypeField;
